import { useState } from 'react';
import Input, { InputProps } from './Input';
import { EyeIcon } from '../../assets/icons';

/** Small slashed-eye for the "hide" state (not part of the Figma icon set). */
function EyeOff({ className = '' }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
      <path
        d="M3 3l18 18M10.6 10.6a2 2 0 002.8 2.8M9.4 5.1A9.5 9.5 0 0112 5c5 0 9 4 10 7a12.4 12.4 0 01-2.4 3.4M6.1 6.1A12.5 12.5 0 002 12c1 3 5 7 10 7 1.6 0 3-.3 4.3-.9"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Password input with a show/hide toggle — replaces antd Input.Password. */
export default function PasswordInput(props: Omit<InputProps, 'type' | 'suffix'>) {
  const [visible, setVisible] = useState(false);
  return (
    <Input
      {...props}
      type={visible ? 'text' : 'password'}
      suffix={
        <button
          type="button"
          aria-label={visible ? 'Hide password' : 'Show password'}
          onClick={() => setVisible((v) => !v)}
          className="flex size-8 items-center justify-center rounded-md text-ink-secondary transition-colors hover:text-brand"
        >
          {visible ? <EyeOff className="size-[18px]" /> : <EyeIcon className="h-[13px] w-[18px]" />}
        </button>
      }
    />
  );
}
